import React from "react";
import "./styles.scss";
import { Box, Typography } from "@material-ui/core";
import { Icon, IconName } from "halifax";
import {
  EarnResponse,
  EarnResponseV2,
  ExperiencesPriceBreakdown,
  RewardsAccount,
} from "redmond";
import clsx from "clsx";
import {
  AVAILABLE,
  getExperimentVariant,
  useExperiments,
  XMOD_V1_EXPERIMENT,
} from "../../../context/experiments";
import { formatRewards } from "../../book/state/utils";

export interface IEarnInfoBannerProps {
  largestValueAccount?: RewardsAccount;
  priceBreakdown?: ExperiencesPriceBreakdown;
  mobile?: boolean;
  cardPaymentAmountRequired?: number;
  earnValueByRewardsAccount?: Record<string, EarnResponseV2 | EarnResponse>;
}

export const EarnInfoBanner = (props: IEarnInfoBannerProps) => {
  const {
    largestValueAccount,
    priceBreakdown,
    mobile,
    cardPaymentAmountRequired,
    earnValueByRewardsAccount,
  } = props;

  const expState = useExperiments();
  const isXmodRedesign =
    getExperimentVariant(expState.experiments, XMOD_V1_EXPERIMENT) ===
    AVAILABLE;

  if (!largestValueAccount || !priceBreakdown || !earnValueByRewardsAccount)
    return null;

  const { earn, productDisplayName, rewardsBalance } = largestValueAccount;
  const totalAmount =
    cardPaymentAmountRequired || priceBreakdown.totalPriceWithFees.fiat.value;
  const earnRateMultipler = earn.experiencesMultiplier;

  const isCashRewards = rewardsBalance.currencyDescription
    ?.toLowerCase()
    .includes("cash");

  const earnValue =
    earnValueByRewardsAccount[largestValueAccount.accountReferenceId];
  let earnAmount = 0;

  if (earnValue && "totalAmount" in earnValue) {
    earnAmount = (earnValue as EarnResponseV2).totalAmount;
  } else {
    earnAmount = isCashRewards
      ? totalAmount * (earnRateMultipler / 100)
      : totalAmount * earnRateMultipler;
  }

  return (
    <Box
      className={clsx("experiences-shop-earn-info-container", {
        mobile,
        xmod: isXmodRedesign,
      })}
    >
      <Icon
        name={IconName.PiggyBankCircleOutline}
        className={clsx("experiences-shop-piggy-bank", {
          xmod: isXmodRedesign,
        })}
      />
      <Typography
        className={clsx("experiences-shop-earn-info-body", {
          xmod: isXmodRedesign,
        })}
      >
        <strong>
          {"Earn "}
          {formatRewards({
            value: earnAmount,
            currency: rewardsBalance.currency,
            currencyDescription: rewardsBalance.currencyDescription || "miles",
          })}
        </strong>
        {` with your ${productDisplayName} card when you book this activity through Capital One Travel.`}
      </Typography>
    </Box>
  );
};
